/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Caster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SystemPermission = 'CreateProjects' | 'ViewProjects' | 'EditProjects' | 'ManageProjects' | 'ImportProjects' | 'LockFiles' | 'ImportResources' | 'ViewUsers' | 'ManageUsers' | 'ViewWorkspaces' | 'ManageWorkspaces' | 'ViewVLANs' | 'ManageVLANs' | 'ViewRoles' | 'ManageRoles' | 'ViewGroups' | 'ManageGroups' | 'ViewHosts' | 'ManageHosts' | 'ViewModules' | 'ManageModules';

export const SystemPermission = {
    CreateProjects: 'CreateProjects' as SystemPermission,
    ViewProjects: 'ViewProjects' as SystemPermission,
    EditProjects: 'EditProjects' as SystemPermission,
    ManageProjects: 'ManageProjects' as SystemPermission,
    ImportProjects: 'ImportProjects' as SystemPermission,
    LockFiles: 'LockFiles' as SystemPermission,
    ImportResources: 'ImportResources' as SystemPermission,
    ViewUsers: 'ViewUsers' as SystemPermission,
    ManageUsers: 'ManageUsers' as SystemPermission,
    ViewWorkspaces: 'ViewWorkspaces' as SystemPermission,
    ManageWorkspaces: 'ManageWorkspaces' as SystemPermission,
    ViewVlans: 'ViewVLANs' as SystemPermission,
    ManageVlans: 'ManageVLANs' as SystemPermission,
    ViewRoles: 'ViewRoles' as SystemPermission,
    ManageRoles: 'ManageRoles' as SystemPermission,
    ViewGroups: 'ViewGroups' as SystemPermission,
    ManageGroups: 'ManageGroups' as SystemPermission,
    ViewHosts: 'ViewHosts' as SystemPermission,
    ManageHosts: 'ManageHosts' as SystemPermission,
    ViewModules: 'ViewModules' as SystemPermission,
    ManageModules: 'ManageModules' as SystemPermission
};

